export const BOLD_KEYBOARD_SHORTCUT = 'mod+b';
export const BOLD_UPCASED_TYPE = 'Bold';
export const BOLD_TAG_NAME = 'strong';
